import "./SubjectConfirmation.css";
import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import {
  formatDateWithoutTime,
  validDateValueRegex,
} from "../../../utilities/helper";

const SubjectConfirmation = ({
  data,
  pageName,
  setShowConfirm,
  languageData,
}) => {
  const navigate = useNavigate();

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link
          className="bread-crumbs-link"
          to="/subject"
          onClick={() => setShowConfirm(false)}
        >
          Subject Management
        </Link>
        | <Link className="bread-crumbs-link">Subject Confirmation</Link>-{" "}
        <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>

      <div className="subject-container">
        <div className="subject-confirmation-container">
          <span className="subject-heading">{pageName}</span>
          <span
            className="subject-heading"
            style={{
              fontSize: "14px",
            }}
          >
            {data?.patientDto?.patientNumber}
          </span>
          <span className="confirmation-heading">
            Confirmation of {pageName}
          </span>
        </div>
        <div className="subject-details-container">
          {languageData?.id !== "00000000-0000-0000-0000-000000000000" ? (
            <div className="subject-details">
              <span className="subject-detail-name">Language</span>
              <span className="subject-detail-value">{languageData?.name}</span>
            </div>
          ) : null}
          {data?.questions
            ?.filter((item) => {
              const value = item?.answers?.[0]?.value;
              return value !== null && value !== undefined && value !== "";
            })
            ?.map((item, index) => {
              const key = item?.questionDisplayText;
              const rawValue = item?.answers?.[0]?.value;

              const skipKey = key === "Visit Name: " || key === "Visit Date: ";

              let displayValue = rawValue;

              // Try parsing if value is a stringified object
              try {
                const parsed =
                  typeof rawValue === "string"
                    ? JSON.parse(rawValue)
                    : rawValue;

                if (parsed && parsed.start && parsed.end) {
                  displayValue = `${formatDateWithoutTime(
                    parsed.start
                  )} - ${formatDateWithoutTime(parsed.end)}`;
                }
              } catch (e) {
                // leave displayValue as-is if parsing fails
              }

              return (
                <div key={index} className="subject-details">
                  {!skipKey && key && (
                    <span className="subject-detail-name">{key}</span>
                  )}

                  {typeof rawValue === "string" &&
                  rawValue?.startsWith("data:image/") &&
                  rawValue?.includes("base64") ? (
                    <img
                      style={{
                        width: "200px",
                        maxHeight: 600,
                        objectFit: "contain",
                      }}
                      src={rawValue}
                      alt="base64"
                    />
                  ) : (
                    !skipKey && (
                      <span className="subject-detail-value">
                        {validDateValueRegex.test(displayValue)
                          ? formatDateWithoutTime(displayValue)
                          : displayValue}
                      </span>
                    )
                  )}
                </div>
              );
            })}
        </div>
      </div>

      <div className="main-subject-details-container">
        <div className="main-details-container">
          {languageData?.id !== "00000000-0000-0000-0000-000000000000" ? (
            <div className="main-subject-details">
              <span className="main-subject-key">Language</span>:
              <span className="main-subject-value">{languageData?.name}</span>
            </div>
          ) : null}
          {data?.questions
            ?.filter((item) => {
              const value = item?.answers?.[0]?.value;
              return value !== null && value !== undefined && value !== "";
            })
            ?.map((item, index) => {
              const key = item?.questionDisplayText;
              const rawValue = item?.answers?.[0]?.value;

              if (!key || key.trim() === "") return null;

              let displayValue = rawValue;
              try {
                const parsed =
                  typeof rawValue === "string"
                    ? JSON.parse(rawValue)
                    : rawValue;

                if (parsed && parsed.start && parsed.end) {
                  displayValue = `${formatDateWithoutTime(
                    parsed.start
                  )} - ${formatDateWithoutTime(parsed.end)}`;
                }
              } catch (e) {
                // Parsing failed — use rawValue as-is
              }

              return (
                <div key={index} className="main-subject-details">
                  {typeof rawValue === "string" &&
                  rawValue?.startsWith("data:image/") &&
                  rawValue?.includes("base64") ? (
                    <>
                      <span className="main-subject-key">{key}</span>:
                      <img
                        style={{
                          width: "200px",
                          maxHeight: 600,
                          objectFit: "contain",
                          marginLeft: "10px",
                        }}
                        src={rawValue}
                        alt="base64"
                      />
                    </>
                  ) : (
                    <>
                      <span className="main-subject-key">
                        {key?.includes(":") ? key.split(":")[0] : key}
                      </span>
                      :
                      <span className="main-subject-value">
                        {" "}
                        {validDateValueRegex.test(displayValue)
                          ? formatDateWithoutTime(displayValue)
                          : displayValue}
                      </span>
                    </>
                  )}
                </div>
              );
            })}
          {/* 
          <div className="main-subject-details">
            <span className="main-subject-key">Subject Status</span>:
            <span className="main-subject-value">
              {data?.patientDto?.patientStatus}
            </span>
          </div> */}
        </div>
      </div>

      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/subject");
            }}
          >
            View Subject
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default SubjectConfirmation;
